import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const Company = React.lazy(() =>
    import('../Company')
);
const companyRoutesRegistry = [
    {
        path: PAGE_URL.COMPANY_PAGE,
        element: <Company />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default companyRoutesRegistry;
